
<modal
  title="Save Comparison"
  :open="open"
  @close="closeModal"
>
  <p class="description">
    Give your custom comparison a name.
  </p>
  <form @submit.stop.prevent="saveComparison">
    <text-input
      id="compare-name"
      ref="nameInput"
      v-model="name"
      type="text"
      label="Name"
      maxlength="40"
    />

    <div
      v-for="(item, i) in items"
      :key="i"
      class="comparison"
    >
      {{ item.label }}
    </div>

    <br />

    <div class="button-row">
      <btn
        type="submit"
        loading-text="Submitting"
        :loading="submitting"
        :disabled="disabled"
      >
        Save
      </btn>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </div>
  </form>
</modal>
